<div class="p-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-2 sm:gap-4">

    <div
        *ngFor="let item of userInfo.otherServicesMenu.items"
        (click)="this.menuService.goTo(item)"
        class="bg-white box-border h-[215px] flex flex-col justify-between px-6 py-4"
    >
        <div class="flex flex-col gap-3">
            <div class="{{ AccountType.isCtop(userInfo.accountType) ? '' : 'text-primary' }}">
                <app-cosentino-svg [svgName]="this.menuService.getIconFileName(item, userInfo.accountType)" [size]="48"></app-cosentino-svg>
            </div>
            <div>
                <div class="typography-title-m">{{ 'menu.' + userInfo.accountType + '.' + item.code | translate }}</div>
            </div>
        </div>

        <div>
            <app-button
                [primary]="true" size="L"
                [block]="true"
                [skin]="AccountType.isCtop(userInfo.accountType) ? 'ctop' : 'we'"
                [gtmLabel]="'go-to_' + item.code"
            >
                {{ 'menu.access' | translate }}
            </app-button>
        </div>
    </div>
</div>
